import React from 'react';
import type { IPageMeta as IPageMetaProps } from '@whitelabel/helpers/types';
import GeneralPageMeta from '@whitelabel/component-library/src/components/PageMeta';
import { SITE_NAME } from '@whitelabel/xcover-shared/helpers/constants';

const PageMeta = ({ ...props }: IPageMetaProps): JSX.Element => {
  const { REACT_APP_MESSAGE_DISPLAY_MODE: MESSAGE_DISPLAY_MODE } = process.env;

  return <GeneralPageMeta {...props} siteName={SITE_NAME} messageDisplayMode={!!MESSAGE_DISPLAY_MODE} />;
};

export default PageMeta;
